import { BaseController } from '../../../../common/base/controller';
import { VisiblePartnerDetailItems } from './partnerDetailItem.constants';

class PartnerItemController extends BaseController {
  constructor(controllerService) {
    'ngInject';
    super({ controllerService });
  }

  set model(value) {
    this.partner = angular.copy(value || {});
    this.partnerCopy = angular.copy(value || {});
  }

  get itemClass() {
    if (this.inline) {
      let col = Math.floor(12 / this.visibleItems.length);
      return `col-md-${col}`;
    }
    return 'col-xs-12';
  }

  $onInit() {
    this.visibleItems = VisiblePartnerDetailItems;
  }

  save($event) {
    this.onSave({ partner: this.partner });
  }

  reset($event) {
    this.partner = this.partnerCopy;
    this.onReset({ partner: this.partner });
  }
}

export default PartnerItemController;
